import gsap from 'gsap';

export function parallax({ e, foreground, background, movement, container }) {
    const containerRect = container.getBoundingClientRect();

    const mousePosition = {
        x: e.x,
        y: e.y,
    };

    // Foreground
    const absolute = {
        x: mousePosition.x - containerRect.left,
        y: mousePosition.y - containerRect.top,
    };

    gsap.to(foreground, {
        x: ((absolute.x - containerRect.width / 2) / containerRect.width) * movement,
        y: ((absolute.y + containerRect.height / 2) / containerRect.height) * movement,
    });

    // Background
    const relative = {
        x: ((mousePosition.x / containerRect.width) * 2 - 1) * 2.5,
        y: ((mousePosition.y / containerRect.height) * 2 - 1) * 2.5,
    };

    gsap.to(background, {
        backgroundPosition: `${relative.x + 55}% ${relative.y + 50}%`,
    });
}
